<template>
    <div class="flex justify-content-between w-full"> 
        <div class="flex-column w-6">
            <p class="p-0 mb-1 text-600 font-semibold">Antrag {{absenceTypeDescription}} <span>{{ absenceAction }}</span></p>
            <h5 class="p-0 m-0">{{data.request.meta.first_name}} {{data.request.meta.last_name}}</h5>
            <p class="p-0 m-0">Von: {{dateToGermanDateStr(new Date(data.request.meta.details.start_date))}}</p>
            <p class="p-0 m-0">Bis: {{dateToGermanDateStr(new Date(data.request.meta.details.end_date))}}</p>
        </div>
        <!-- <div v-if="data.request.action !== 'delete' && userRole === 'admin'" class="flex justify-content-start align-items-start"> -->
        <div class="flex w-6 align-items-center" :class="detailsButtonArrangementClass">
            <i v-if="userRole === 'admin'" class="pi pi-info-circle message-icon mr-3" @click="showDetails"/>
            <i v-badge="numMessages" class="pi pi-envelope message-icon" @click="toggle"/>
        </div>

        <OverlayPanel ref="op" class="border-round-3xl p-shiftify-chat">
            <div class="overlay-panel">
                <Chat 
                :employeeId="userId" 
                :messages="messages" 
                :requestId="data.request.id"
                @updateParent="updateComponent"
                />
            </div> 
        </OverlayPanel>
    </div>
</template>

<script>
import {dateToGermanDateStr} from '../../../js_utilities/dateUtils.js';
import Chat from '../../Chat/Chat.vue'
export default {
    components: {Chat},

    data() {
        return {
            userRole: null,
            userId: null,
            dateToGermanDateStr
        }
    },

    props: {
        data: {
            type: Object,
            required: true
        }
    },

    emits: ["close", "updateParent"],

    methods: {

        toggle(event) {
            this.$refs.op.toggle(event);
        },

        showDetails(){
            let department_id = this.data.request?.requester_employee?.department?.id || null;
            
            if (department_id !== null){
                this.$router.push({ 
                    path: `/holidayplanner/${this.data.request.meta.details.start_date}/${this.data.request.meta.details.end_date}/${department_id}`, 
                });
            } else {
                this.$router.push({ 
                    path: `/holidayplanner/${this.data.request.meta.details.start_date}/${this.data.request.meta.details.end_date}`, 
                });
            }
            this.$emit("close")

        },
        
        updateComponent() {
            console.log("updateParent from RequestDailyAbsenceDetails component")
            this.$emit("updateParent")
        },
        
    },

    computed: {
        detailsButtonArrangementClass() {
            // return this.userRole === 'admin' ? "justify-content-between" : "justify-content-end"
            return "justify-content-end"
        },

        numMessages(){
            return this.data?.request?.messages?.length.toString() ?? "0";
        },

        messages(){
            return this.data?.request?.messages ?? [];
        },

        germanDateStrFromIsoDateStr(isoDateStr) {
            return dateToGermanDateStr(new(Date(isoDateStr)))
        },

        absenceTypeDescription(){
            if (this.data.request.meta.absence_type  === null || this.data.request.meta.absence_type  === undefined) {
                return "Abwesenheit"
            } else {
                return this.data.request.meta.absence_type.name
            }
        },

        absenceAction(){
            if (this.data.request.action == "delete") {
                return "(Löschung)"
            } else if (this.data.request.action == "update") {
                return "(Änderung)"
            } else {
                return ""
            }
        }
    },

    created(){
        this.userRole = this.$store.getters.getLoggedInUser.role.name
        this.userId = this.$store.getters.getLoggedInUser.uuid
    }
}
</script>

<style scoped>
.label-text {
    font-size: 1rem !important;
  }

.button-height{
    height: 1.5rem;
}

.p-button{
    color: rgba(60, 55, 220, 1.0) !important;
    background-color: rgba(60, 55, 220, 0.05) !important;
}

.p-button:hover{
    color: rgba(60, 55, 220, 1.0) !important;
    background-color: rgba(60, 55, 220, 0.25) !important;
}

.overlay-panel {
    width: 50vw;
    height: 50vh;
}


.message-icon{
    font-size: 1.5rem;
    transition: font-size 0.15s ease-in-out;
}

.message-icon:hover{
    font-size: 1.75rem
}

</style>
